import './bootstrap';
import App from './App.vue'
import router from './routes';
import store from './store';
import { Settings } from './utils/settings';
import { Polyglot } from './utils/polyglot';
import { Asset } from './utils/assets';
import { Api } from './utils/api';
import { StepHelper } from './utils/step-helper';


window.DForce = function (options) {
   let self = this;
    let locale = options.locale;
    let locales = options.locales;
    let uuid = getQueryVariable('uuid');
    let token = getQueryVariable('token');
    let vm = null;

    self.settings = new Settings(options);

    self.getSetting = function (name) {
        return self.settings.getSetting(name);
    }

    self.assetUrl = function(file) {
        let pathAssets = self.getSetting('paths.assets');
        return pathAssets + file;
    }

    // Global t-function for handling translations
    window.t = function(name, placeholders) {
        return self.Polyglot.text(name, placeholders);
    }

    self.setLanguage = function(locale, doWhenReady) {
        if(locale == store.state.activeLocale) {
            if(doWhenReady) {
                doWhenReady();
            }

            return;
        }
        self.Polyglot.fetchUri = self.getSetting('paths.baseApiUrl')  + locale + '/locale/translation' + '?uuid=' + uuid + '&token=' + token;
        self.Polyglot.pushUri = self.getSetting('paths.baseApiUrl')  + locale + '/locale/translate';

        self.fetchTranslations(locale,function(){
            // when the new dictionary is loaded set the new locale
            // the component that watch this value wil be updated
            store.commit('setActiveLocale',locale);

            if(doWhenReady) {
                doWhenReady();
            }
        });
    }

    self.fetchTranslations = function(locale, doWhenReady) {
        if(! locale) {
            return doWhenReady();
        }

        // Fetch default translations
        self.Polyglot.fetch(doWhenReady);
    }

    self.initiateVue = function () {
        self.vm =new Vue({
            el: '#app',
            render: h => h(App),
            router: router,
            store: store,
            data: {
                locales: locales,
                theme: null,
            }
        });
    }

    // Bind the DForce function to Vue
    // self way we can access easily these methods in child components through "self.$root.$AppKit.function()"
    Vue.prototype.$DForce = self;
    Vue.prototype.$Api = new Api(self.getSetting('paths.baseApiUrl'),locale);
    Vue.prototype.$StepHelper = new StepHelper();


    // Polyglot for handling translations
    self.Polyglot = new Polyglot();
    self.setLanguage(locale, self.initiateVue);
    Vue.prototype.t = window.t;
};

function getQueryVariable(variable)
{
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
    }
    return(false);
}



// WEBPACK FOOTER //
// ./src/main.js